import { useEffect, useState } from 'react';
import { fetchImage } from '../lib/api';
import { dayApi } from '../lib/day';

/**
 * A stored receipt photo, fetched WITH the session token — the browser sends
 * no Authorization header on an image request, so a plain `src` would come
 * back 401. Same reasoning as SignatureImage.
 */
export default function ReceiptImage({ id }: { id: string }) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let live = true;
    let objectUrl: string | null = null;
    fetchImage(dayApi.receiptUrl(id))
      .then((blob) => {
        objectUrl = URL.createObjectURL(blob);
        if (live) setUrl(objectUrl);
      })
      .catch(() => { if (live) setFailed(true); });

    return () => {
      live = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [id]);

  if (failed) return <div className="sub" style={{ marginTop: 4 }}>The photo could not be loaded.</div>;
  if (!url) return <div className="sub" style={{ marginTop: 4 }}>Loading the photo…</div>;
  return (
    <img
      src={url}
      alt="Receipt"
      style={{ display: 'block', maxWidth: '100%', maxHeight: 320, borderRadius: 10, marginTop: 6 }}
    />
  );
}
